import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FAQSystem from '../components/faq/FAQSystem';
import Seo from '../components/Seo';
import { faqData } from '../data/faq/faqData';
const FAQSystemPage = () => {
    const { t } = useTranslation();
    const faqJsonLd = useMemo(() => {
        const topFaqs = [...faqData]
            .sort((a, b) => b.priority - a.priority)
            .slice(0, 12);
        return {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: topFaqs.map((item) => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: { '@type': 'Answer', text: item.answer },
            })),
        };
    }, []);
    return (_jsxs("div", { style: { paddingTop: '50px' }, children: [_jsx(Seo, { title: t('seo.help.title', 'Hilfe & Anleitungen für Garmin Watchfaces – TitanicTurtle'), description: t('seo.help.description', 'Anleitungen und FAQ für Garmin Watchfaces: Installation, Kauf (VX/Elite), Wetter, Gezeiten, GPS, Themes und Fehlerbehebung – Schritt für Schritt erklärt.'), canonicalPath: "/help", keywords: "Garmin Watchface Anleitung, Watchface installieren, VX Elite Unterschied, Wetter einrichten, Gezeiten, GPS Fix", jsonLd: [faqJsonLd] }), _jsx(FAQSystem, {})] }));
};
export default FAQSystemPage;
